















































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IQuestion } from "@/store/modules/content/types";
import { IUSection } from "@/store/types";
import AudioPlayer from "@/components/ccat/AudioPlayer.vue";

@Component({
  name: "question-control",
  components: {
    AudioPlayer,
  },
})
export default class QuestionControl extends Vue {
  @Prop({ default: 1 })
  public questionNum!: number;

  @Prop({ default: 4 })
  public ct!: number;

  @Prop({ default: 0 })
  public ctAnswered!: number;

  @Prop({ default: false })
  public finished!: boolean;

  @Prop({ default: {} })
  public question!: IQuestion;

  @Prop({ default: {} })
  public section!: IUSection;

  @Prop({ default: null, type: Array })
  public questions!: IQuestion[] | any;

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: false })
  public hasError!: boolean;

  @Prop({ default: false })
  public sortingAnswers!: boolean;

  @Prop({ default: "" })
  public optionOver!: string;

  @Prop({ default: "" })
  public optionSelected!: string;

  @Prop({ default: false, type: Boolean })
  public disableFinishTestButton!: boolean;

  @Prop({ default: null, type: Array })
  public answerObj!: [];

  public btnNextQuestion = true;
  public btnPrevQuestion = true;
  private submitAnswersModalOpened: boolean = false;
  private selected: number[] | string | null = "";
  private isProcessingOption = false;
  public preventOptionClick = false;

  @Watch("optionSelected", { immediate: true })
  public onSelectChoice(val: string) {
    this.selected = val;
  }

  public checkInCorrect(k: string) {
    return (
      this.section &&
      this.section.is_completed &&
      this.section.correct &&
      this.section.correct[this.questionNum] === k &&
      !this.checkCorrect(k)
    );
  }

  public checkCorrect(k: string) {
    return (
      this.section &&
      this.section.is_completed &&
      this.selected === k &&
      this.section.correct &&
      this.section.correct[this.questionNum] === this.selected
    );
  }

  public showSubmitAnswersBtn() {
    if (this.section.is_completed) {
      return false;
    } else {
      return this.finished;
    }
  }

  get buttons(): any {
    return [
      {
        type: "success",
        label: "Submit my answers",
        event: "submit-answers:clicked",
      },
    ];
  }

  get options() {
    const options: any = this.question.choice_obj || this.question.options;
    if (options) {
      const orderedOptions: any = {};
      Object.keys(options)
        .sort()
        .forEach(function(key) {
          orderedOptions[key] = options[key];
        });

      return orderedOptions;
    } else {
      return {};
    }
  }

  get blockButtons(): boolean {
    return this.isLoading || this.hasError || this.sortingAnswers;
  }

  public onSubmit(): void {
    this.$emit("answers:submit");
  }

  public onQuestionControl(type: string): void {
    let ret: number = 0;

    if (type === "next") {
      const next: number = this.questionNum + 1;
      ret = next <= this.ct ? next : this.ct;
    } else {
      const prev: number = this.questionNum - 1;
      ret = prev >= 1 ? prev : 1;
    }

    this.goToQuestion(ret);
  }

  public checkQuestionControl(type: string): boolean {
    if (type === "next") {
      if (
        !this.blockButtons &&
        this.getQuestionByNum(this.questionNum).student_answer &&
        this.questionNum < this.ct &&
        this.getQuestionByNum(this.questionNum + 1).student_answer
      ) {
        return false;
      } else {
        return (
          this.questionNum === this.ct ||
          this.ctAnswered <= this.questionNum ||
          !this.getQuestionByNum(this.questionNum).student_answer ||
          this.blockButtons
        );
      }
    } else {
      return this.questionNum === 1 || this.blockButtons;
    }
  }

  public getQuestionByNum(num: number) {
    const question =
      this.questions &&
      this.questions.find((q: { num: number }) => q.num === num);
    return question || null;
  }

  public goToQuestion(num: number) {
    this.$emit("question:control", num);
  }

  public onMouseEnter(option: string) {
    this.$emit("option:over", option);
  }

  public onMouseLeave(option: string) {
    this.$emit("option:over", "");
  }

  public onOptionClick(option: string) {
    if (this.isProcessingOption) {
      return;
    }

    this.isProcessingOption = true;
    this.selected = option;

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    setTimeout(async function() {
      if (!self.section.is_completed) {
        if (!self.preventOptionClick) {
          self.$emit("option:selected", option);
        }
        self.preventOptionClick = false;
      }
    }, 100);

    this.isProcessingOption = false;
  }

  public onOptionAudioClick() {
    this.preventOptionClick = true;
  }

  public onDoneClick() {
    if (!this.preventOptionClick) {
      this.selected = this.answerObj;
      this.$emit("option:selected", this.answerObj);
    }
  }

  public onIDKClick() {
    if (!this.preventOptionClick) {
      this.selected = "SKIP";
      this.$emit("option:selected", "SKIP");
    }
  }

  public studentAnswerStr(student_answer: Map<number, number> | string) {
    if (student_answer && typeof student_answer !== "string") {
      return Object.values(student_answer).join(",");
    } else {
      if (student_answer === "SKIP") {
        return "I'm not sure";
      } else {
        return student_answer;
      }
    }
  }
}
